export default {
  ALL_ALL: "ALL_ALL",
  CRYPTO_CRYPTO: "CRYPTO_CRYPTO",
};
